<!-- User Segments Section -->
<section class="segments-section">
  <div class="section-container">
    <div class="section-header">
      <h2 class="section-title">Built for Every Education Professional</h2>
      <p class="section-subtitle">
        Tailored experiences for students, teachers, parents, and administrators
      </p>
    </div>
    <div class="segments-grid">
      <div class="segment-card" *ngFor="let segment of userSegments; let i = index">
        <div class="segment-header">
          <div class="segment-icon-wrapper">
            <span class="segment-icon">{{ segment.icon }}</span>
          </div>
          <div class="segment-info">
            <h3 class="segment-title">{{ segment.title }}</h3>
            <p class="segment-description">{{ segment.description }}</p>
          </div>
        </div>
        <div class="segment-features">
          <div class="feature-list">
            <div class="feature-item" *ngFor="let feature of segment.features">
              <span class="feature-check">✓</span>
              <span class="feature-text">{{ feature }}</span>
            </div>
          </div>
        </div>
        <div class="segment-gradient"></div>
      </div>
    </div>
  </div>
</section>